<template>
  <div class="home" id="home">
    <vue-headful title="Mannschaft - FF Pfaffenhofen"/>
    <Header :menu-at="0" headerTitle="Mannschaft"/>
    <div class="container header-container">
      <h1>Wer wir sind und Was wir machen</h1>
      <p>Die Freiwillige Feuerwehr Pfaffenhofen besteht aus der <b>aktiven Mannschaft</b> , der <b>Jugendgruppe</b>,
         den <b>passiven Mitgliedern</b> und den <b>fördernden Vereinsmitgliedern</b>. 
         <br><br>
         Für den Schutz der Marktgemeinde Pfaffenhofen
         stehen rund 64 Männer und Frauen im aktiven Dienst bereit. Sie helfen den Bürgern zu jeder Tages- und Nachtzeit in Notlagen.
         24 Stunden am Tag, 7 Tage die Woche und 365 Tage im Jahr. Dieser Dienst ist wohlgemerkt ehrenamtlich und unentgeltlich. 
         <br><br>
         Die Jugendgruppe mit 14 Mitgliedern - 4 Mädels und 10 Jungs - sichert den Nachwuchs unserer Wehr.
      </p>
    </div>
    <div class="container text-container">
      <h1>Leitung</h1>
      <div class="flex-row">
        <div class="card">
          <div class="card-flex">
            <div class="content">
              <p class="role">Kommandant</p>
              <p class="name">Schmucker Torsten</p>
              <div class="btn-group">
                <a class="entry" href="mailto:torsten.schmucker@ff-pfaffenhofen.de" title="Email schreiben">
                  <font-awesome-icon icon="envelope" />
                </a>
              </div>
            </div>
            <div class="image">
              <img src="/group/na.jpg" height="100px" width="100px" draggable="false">
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-flex">
            <div class="content">
              <p class="role">stv. Kommandant </p>
              <p class="name">Kast Günther</p>
              <div class="btn-group">
                <a class="entry" href="mailto:guenther.kast@ff-pfaffenhofen.de" title="Email schreiben">
                  <font-awesome-icon icon="envelope" />
                </a>
              </div>
            </div>
            <div class="image">
              <img src="/group/na.jpg" height="100px" width="100px" draggable="false">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container text-container">
      <h1>Gruppenführer</h1>
      <div class="flex-row">
        <!--  -->
        <div class="card">
          <div class="card-flex">
            <div class="content">
              <p class="role">Gruppenführer </p>
              <p class="name">Dirr Philipp</p>
              <div class="btn-group">
                <a class="entry" href="mailto:philipp.dirr@ff-pfaffenhofen.de" title="Email schreiben">
                  <font-awesome-icon icon="envelope" />
                </a>
              </div>
            </div>
            <div class="image">
              <img src="/group/na.jpg" height="100px" width="100px" draggable="false">
            </div>
          </div>
        </div>
        <!--  -->
        <div class="card">
          <div class="card-flex">
            <div class="content">
              <p class="role">Gruppenführer</p>
              <p class="name">Geisinger Yannik</p>
              <div class="btn-group">
                <a class="entry" href="mailto:yannik.geisinger@ff-pfaffenhofen.de" title="Email schreiben">
                  <font-awesome-icon icon="envelope" />
                </a>
              </div>
            </div>
            <div class="image">
              <img src="/group/na.jpg" height="100px" width="100px" draggable="false">
            </div>
          </div>
        </div>
        <!--  -->
        <div class="card">
          <div class="card-flex">
            <div class="content">
              <p class="role">Gruppenführer</p>
              <p class="name">Glinka Joachim</p>
              <div class="btn-group">
                <a class="entry" href="mailto:joachim.glinka@ff-pfaffenhofen.de" title="Email schreiben">
                  <font-awesome-icon icon="envelope" />
                </a>
              </div>
            </div>
            <div class="image">
              <img src="/group/na.jpg" height="100px" width="100px" draggable="false">
            </div>
          </div>
        </div>
        <!--  -->
        <div class="card">
          <div class="card-flex">
            <div class="content">
              <p class="role">Gruppenführer</p>
              <p class="name">Herrmann Jochen</p>
              <div class="btn-group">
                <a class="entry" href="mailto:jochen.herrmann@ff-pfaffenhofen.de" title="Email schreiben">
                  <font-awesome-icon icon="envelope" />
                </a>
              </div>
            </div>
            <div class="image">
              <img src="/group/na.jpg" height="100px" width="100px" draggable="false">
            </div>
          </div>
        </div>
        <!--  -->
        <div class="card">
          <div class="card-flex">
            <div class="content">
              <p class="role">Gruppenführer</p>
              <p class="name">Himmel Daniel</p>
              <div class="btn-group">
                <a class="entry" href="mailto:daniel.himmel@ff-pfaffenhofen.de" title="Email schreiben">
                  <font-awesome-icon icon="envelope" />
                </a>
              </div>
            </div>
            <div class="image">
              <img src="/group/na.jpg" height="100px" width="100px" draggable="false">
            </div>
          </div>
        </div>
        <!--  -->
        <div class="card">
          <div class="card-flex">
            <div class="content">
              <p class="role">Gruppenführer</p>
              <p class="name">Hinz Anja</p>
              <div class="btn-group">
                <a class="entry" href="mailto:anja.hinz@ff-pfaffenhofen.de" title="Email schreiben">
                  <font-awesome-icon icon="envelope" />
                </a>
              </div>
            </div>
            <div class="image">
              <img src="/group/na.jpg" height="100px" width="100px" draggable="false">
            </div>
          </div>
        </div>
        <!--  -->
        <div class="card">
          <div class="card-flex">
            <div class="content">
              <p class="role">Gruppenführer</p>
              <p class="name">Jehle Markus</p>
              <div class="btn-group">
                <a class="entry" href="mailto:markus.jehle@ff-pfaffenhofen.de" title="Email schreiben">
                  <font-awesome-icon icon="envelope" />
                </a>
              </div>
            </div>
            <div class="image">
              <img src="/group/na.jpg" height="100px" width="100px" draggable="false">
            </div>
          </div>
        </div>
        <!--  -->
        <div class="card">
          <div class="card-flex">
            <div class="content">
              <p class="role">Gruppenführer</p>
              <p class="name">Lindstedt Christian</p>
              <div class="btn-group">
                <a class="entry" href="mailto:christian.lindstedt@ff-pfaffenhofen.de" title="Email schreiben">
                  <font-awesome-icon icon="envelope" />
                </a>
              </div>
            </div>
            <div class="image">
              <img src="/group/na.jpg" height="100px" width="100px" draggable="false">
            </div>
          </div>
        </div>
        <!--  -->
        <div class="card">
          <div class="card-flex">
            <div class="content">
              <p class="role">Gruppenführer</p>
              <p class="name">Looser Ziyade</p>
              <div class="btn-group">
                <a class="entry" href="mailto:ziyade.looser@ff-pfaffenhofen.de" title="Email schreiben">
                  <font-awesome-icon icon="envelope" />
                </a>
              </div>
            </div>
            <div class="image">
              <img src="/group/na.jpg" height="100px" width="100px" draggable="false">
            </div>
          </div>
        </div>
        <!--  -->
        <div class="card">
          <div class="card-flex">
            <div class="content">
              <p class="role">Gruppenführer</p>
              <p class="name">Schlumberger Lukas</p>
              <div class="btn-group">
                <a class="entry" href="mailto:lukas.schlumberger@ff-pfaffenhofen.de" title="Email schreiben">
                  <font-awesome-icon icon="envelope" />
                </a>
              </div>
            </div>
            <div class="image">
              <img src="/group/na.jpg" height="100px" width="100px" draggable="false">
            </div>
          </div>
        </div>
        <!--  -->
        <div class="card">
          <div class="card-flex">
            <div class="content">
              <p class="role">Gruppenführer</p>
              <p class="name">Schweiggert Andreas</p>
              <div class="btn-group">
                <a class="entry" href="mailto:andreas.schweiggert@ff-pfaffenhofen.de" title="Email schreiben">
                  <font-awesome-icon icon="envelope" />
                </a>
              </div>
            </div>
            <div class="image">
              <img src="/group/na.jpg" height="100px" width="100px" draggable="false">
            </div>
          </div>
        </div>
        <!--  -->
        <div class="card">
          <div class="card-flex">
            <div class="content">
              <p class="role">Gruppenführer</p>
              <p class="name">Schweiggert Thomas</p>
              <div class="btn-group">
                <a class="entry" href="mailto:thomas.schweiggert@ff-pfaffenhofen.de" title="Email schreiben">
                  <font-awesome-icon icon="envelope" />
                </a>
              </div>
            </div>
            <div class="image">
              <img src="/group/na.jpg" height="100px" width="100px" draggable="false">
            </div>
          </div>
        </div>
        <!--  -->
        <div class="card">
          <div class="card-flex">
            <div class="content">
              <p class="role">Zugführer</p>
              <p class="name">Stölzle Mathias</p>
              <div class="btn-group">
                <a class="entry" href="mailto:mathias.stölzle@ff-pfaffenhofen.de" title="Email schreiben">
                  <font-awesome-icon icon="envelope" />
                </a>
              </div>
            </div>
            <div class="image">
              <img src="/group/na.jpg" height="100px" width="100px" draggable="false">
            </div>
          </div>
        </div>
        <!--  -->
        <div class="card">
          <div class="card-flex">
            <div class="content">
              <p class="role">Gruppenführer</p>
              <p class="name">Wolf Dominik</p>
              <div class="btn-group">
                <a class="entry" href="mailto:dominik.wolf@ff-pfaffenhofen.de" title="Email schreiben">
                  <font-awesome-icon icon="envelope" />
                </a>
              </div>
            </div>
            <div class="image">
              <img src="/group/na.jpg" height="100px" width="100px" draggable="false">
            </div>
          </div>
        </div>
        <!--  -->
        <div class="card">
          <div class="card-flex">
            <div class="content">
              <p class="role">Gruppenführer</p>
              <p class="name">Zender Manuel</p>
              <div class="btn-group">
                <a class="entry" href="mailto:manuel.zender@ff-pfaffenhofen.de" title="Email schreiben">
                  <font-awesome-icon icon="envelope" />
                </a>
              </div>
            </div>
            <div class="image">
              <img src="/group/na.jpg" height="100px" width="100px" draggable="false">
            </div>
          </div>
        </div>
        <!--  -->
      </div>
    </div>

    <div class="container text-container">
      <h1>Jugendwarte</h1>
      <div class="flex-row">
        <!--  -->
        <div class="card">
          <div class="card-flex">
            <div class="content">
              <p class="role">Jugendwartin</p>
              <p class="name">Looser Ziyade</p>
              <div class="btn-group">
                <a class="entry" href="mailto:ziyade.looser@ff-pfaffenhofen.de" title="Email schreiben">
                  <font-awesome-icon icon="envelope" />
                </a>
              </div>
            </div>
            <div class="image">
              <img src="/group/na.jpg" height="100px" width="100px" draggable="false">
            </div>
          </div>
        </div> 
        <!--  -->
        <div class="card">
          <div class="card-flex">
            <div class="content">
              <p class="role">Jugendwart</p>
              <p class="name">Geisinger Yannik</p>
              <div class="btn-group">
                <a class="entry" href="mailto:yannik.geisinger@ff-pfaffenhofen.de" title="Email schreiben">
                  <font-awesome-icon icon="envelope" />
                </a>
              </div>
            </div>
            <div class="image">
              <img src="/group/na.jpg" height="100px" width="100px" draggable="false">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container text-container">
      <h1>Leitung Atemschutz</h1>
      <div class="flex-row">
        <!--  -->
        <div class="card">
          <div class="card-flex">
            <div class="content">
              <p class="role">Atemschutz</p>
              <p class="name">Glinka Joachim</p>
              <div class="btn-group">
                <a class="entry" href="mailto:joachim.glinka@ff-pfaffenhofen.de" title="Email schreiben">
                  <font-awesome-icon icon="envelope" />
                </a>
              </div>
            </div>
            <div class="image">
              <img src="/group/na.jpg" height="100px" width="100px" draggable="false">
            </div>
          </div>
        </div>
        <!--  -->
        <div class="card">
          <div class="card-flex">
            <div class="content">
              <p class="role">Atemschutz</p>
              <p class="name">Schweiggert Andreas</p>
              <div class="btn-group">
                <a class="entry" href="mailto:andreas.schweiggert@ff-pfaffenhofen.de" title="Email schreiben">
                  <font-awesome-icon icon="envelope" />
                </a>
              </div>
            </div>
            <div class="image">
              <img src="/group/na.jpg" height="100px" width="100px" draggable="false">
            </div>
          </div>
          <!--  -->
        </div>
      </div>
    </div>
    
    <Footer />
    <Scroll2Top />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Scroll2Top from '@/components/Scroll2Top.vue'

export default {
  name: 'home',
  components: {
    Header, Footer, Scroll2Top
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/theme.scss";

.header-container {
  padding-top: 100px;
}


h1 {
  text-align: center;

  @include tablet {
    text-align: left;
  }
}

p {
  opacity: 0.8;
}

.flex-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-top: 20px;
  margin-bottom: 20px;
  align-items: center;
}

.card {
  width: 90%;
  margin: 5px 5% 10px 5%;
  height: 120px;
  background: $light-0;
  border-radius: 4px;
  box-shadow: $shadow-light;
  margin-bottom: 10px;
  border: 1px solid lighten($gray-0, 20%);

  @include tablet {
    width: 46%;
    margin: 0px 1% 10px 1%;
  }
  
  
  @include tablet {
    width: 42%;
    margin: 0px 3% 10px 3%;
  }


}

.card:nth-child(even) .card-flex {
  flex-direction: row-reverse;

  @include tablet {
    flex-direction: row;
  }
}

.card-flex {
  display: flex;
  height: 120px;

  .content {
    width: 65%;
    padding-left: 20px;

    .name {
      margin-top: -10px;
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .role {
      margin-top: 20px;
      color: $primary-0;
      font-size: 14px;
      font-weight: bold;
      text-transform: uppercase;
    }

  }

  .image {
    width: 35%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid lighten($gray-0, 20%);
    border-right: 1px solid lighten($gray-0, 20%);
    
    img {
      object-fit: cover;
      border-radius: 100%;

    }
  }
}

.btn-group {
  a {
    background: none;
    border: none;
    color: $dark;
    font-size: 20px;
    cursor: pointer;
    padding: 0px;
    opacity: 0.7;

    &:hover {
      color: $primary-0;
      opacity: 1;
      transition: 0.5s;
    }
  }
}

</style>
